export const contact = {
  title: 'お問い合わせ',
  subtitle: 'ご質問やご要望がございましたら、お気軽にお問い合わせください',
  
  // Form Labels
  name: 'お名前',
  namePlaceholder: 'お名前を入力してください',
  
  email: 'メールアドレス',
  emailPlaceholder: 'your.email@example.com',
  
  message: 'お問い合わせ内容',
  messagePlaceholder: 'お問い合わせ内容を入力してください',
  messageLimit: '1000文字以内',
  
  // Submit
  submitButton: '送信する',
  submittingButton: '送信中...',
  
  // Messages
  successMessage: 'お問い合わせを受け付けました。ご連絡をお待ちください。',
  errorMessage: 'エラーが発生しました。もう一度お試しください。',
  fillRequired: '必須項目を入力してください',
  messageTooLong: 'メッセージは1000文字以内で入力してください'
};
